
var ch = null;
const _callback = (ch, callbackFns) => {
    ch.join().receive("ok", resp => {
        callbackFns.join(resp.tickets)
    });

  ch.on("ticket_update", (resp) => {
    callbackFns.update(resp);
  });
  ch.on("remove_item", (resp) => {
    callbackFns.removeItem(resp);
  });

    ch.on("ticket_closed", resp => {
        callbackFns.remove(resp.ticket_name);
    });
}

const _connectCh = (socketConn, callbackFns, chName, params = {}) => {
    let connect = () => {
        ch = socketConn.channel(chName, params)
        if (!ch) {
            console.log("error connecting ch:", chName);
            return
        }
        _callback(ch, callbackFns);
        return ch;
    }
    if (ch) {
        ch.leave().receive("ok", () => {
            ch = null;
            connect();
        })
    } else {
        connect();
    }
}

const _connect_chef = (socketConn, callbackFns, storeId, klStoreId) => {
    return _connectCh(socketConn, callbackFns, `chef:${klStoreId}`, {storeId, klStoreId});
}
const _connect_kl = (socketConn, callbackFns, storeId, klStoreId, klId) => {
    return _connectCh(socketConn, callbackFns, `kds:${klId}`, { storeId, klStoreId });
}

const join = (socketConn, callbackFns, storeId, klStoreId, klId) => {
    if (klId) {
        _connect_kl(socketConn, callbackFns, storeId, klStoreId, klId);
    } else {
        _connect_chef(socketConn, callbackFns, storeId, klStoreId);
    }
}

const leave = () => {
    if (ch) {
        ch.leave().receive("ok", () => {
            ch = null;
        })
    }
}

export default {
    join,
    leave
}